import { ClaimModel } from "../models/role.model";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, Router } from "@angular/router";
import { ClaimsService } from "../services/claims.service";

@Injectable()
export class ClaimsResolver implements Resolve<ClaimModel[]> {
    constructor(
        private router: Router,
        private claimsService: ClaimsService
    ) {}

    resolve(route: ActivatedRouteSnapshot) {

        const isAdmin = this.claimsService.isAdmin();

        if (isAdmin) this.router.navigate(["/portal/admin"]);

        return this.claimsService.getAsKeyValue();
    }
}
